module.exports = __webpack_public_path__ + "img/027-storm-16.55d41809.svg";